import { useEffect, useState } from 'react';

const DESKTOP_BREAKPOINT = 1024;

export const useIsMobileScreenSize = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < DESKTOP_BREAKPOINT);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < DESKTOP_BREAKPOINT);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return isMobile;
};
